import React from 'react';
import { Modal, Form, Input, Row, Col, Alert, Button } from 'antd';
import useApi from '../../hooks/useApi';

const EditarSenha = ({ open, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const is_primeiro_login = JSON.parse(localStorage.getItem('is_primeiro_login') || 'false');

  

  const { callApi: changePassword, loading: isSubmitting } = useApi('https://vision.alfama.com/api/update/senha', {
    method: 'PUT',
    includeToken: true,
    successMessage: 'Senha atualizada com sucesso!',
    errorMessage: 'Erro ao atualizar senha. Verifique suas credenciais.',
    onError: (error) => {
      if (error.response?.status === 401) {
        form.setFields([
          {
            name: 'senhaAtual',
            errors: ['Senha atual incorreta'],
          },
        ]);
      }
    }
  });

  const handleSubmit = async (values) => {
    const dataToSend = {
      senhaAtual: values.senhaAtual,
      novaSenha: values.novaSenha
    };
    
    const response = await changePassword(dataToSend);
    if (response) {
      form.resetFields();
      if (is_primeiro_login) {
        localStorage.setItem('is_primeiro_login', 'false');
        if (onSuccess) onSuccess();
      }
      onClose();
    }
  };

  const handleClose = () => {
    if (!is_primeiro_login) {
      form.resetFields();
      onClose();
    }
  };

  return (
    <Modal
      title={is_primeiro_login ? "Alterar Senha Temporária" : "Alterar Senha"}
      open={open}
      onCancel={handleClose}
      okText="Alterar Senha"
      width={500}
      confirmLoading={isSubmitting}
      onOk={() => form.submit()}
      closable={!is_primeiro_login}
      maskClosable={!is_primeiro_login}
      keyboard={!is_primeiro_login}
      footer={[
        !is_primeiro_login && (
          <Button key="cancel" onClick={handleClose}>
            Cancelar
          </Button>
        ),
        <Button 
          key="submit" 
          type="primary" 
          loading={isSubmitting} 
          onClick={() => form.submit()}
        >
          Alterar Senha
        </Button>
      ].filter(Boolean)}
    >
      {is_primeiro_login && (
        <Alert
          message="Primeiro Acesso"
          description="Por questões de segurança, você precisa alterar sua senha temporária para uma nova senha de sua escolha."
          type="info"
          showIcon
          style={{ marginBottom: 24 }}
        />
      )}

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name="senhaAtual"
              label={is_primeiro_login ? "Senha Temporária" : "Senha Atual"}
              rules={[
                { required: true, message: `Por favor, insira sua senha ${is_primeiro_login ? 'temporária' : 'atual'}` },
                { min: 6, message: 'A senha deve ter no mínimo 6 caracteres' }
              ]}
            >
              <Input.Password placeholder={`Digite sua senha ${is_primeiro_login ? 'temporária' : 'atual'}`} />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              name="novaSenha"
              label="Nova Senha"
              rules={[
                { required: true, message: 'Por favor, insira a nova senha' },
                { min: 6, message: 'A senha deve ter no mínimo 6 caracteres' }
              ]}
              hasFeedback
            >
              <Input.Password placeholder="Digite uma nova senha" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              name="confirmarSenha"
              label="Confirmar Nova Senha"
              dependencies={['novaSenha']}
              rules={[
                { required: true, message: 'Por favor, confirme a nova senha' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('novaSenha') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('As senhas não correspondem'));
                  },
                }),
              ]}
              hasFeedback
            >
              <Input.Password placeholder="Confirme a nova senha" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditarSenha;